/* eslint-disable react/prop-types */
/* eslint-disable camelcase */
import styled from '@emotion/styled';
import React, { useRef } from 'react';

import { QrCodeSvg, QrCodeCanvas, svgToDataUrl } from './qr_helper';
import AlertMessage from '../../OC/oc-alert-message';
import RichText from '../../OC/oc-rich-text';

const QrSection = ({ title, url }) => {
  const svgRef = useRef();
  const canvasRef = useRef();
  return (
    <div>
      <div style={{ maxWidth: '200px' }}>
        <QrCodeSvg ref={svgRef} url={url} />
      </div>
      {/* the canvas dom element must render, even if hidden, because we need it for toDataURL */}
      <div style={{ display: 'none' }}>
        <QrCodeCanvas ref={canvasRef} url={url} />
      </div>
      <p>
        <a href={svgToDataUrl(svgRef.current)} download={`qr_code_${title}.svg`}>
          Download SVG
        </a>
        {' | '}
        <a href={canvasRef.current?.toDataURL('image/png')} download={`qr_code_${title}.png`}>
          Download PNG
        </a>
        {' | '}
        <a href={canvasRef.current?.toDataURL('image/jpeg')} download={`qr_code_${title}.jpg`}>
          Download JPG
        </a>
      </p>
    </div>
  );
};

const PreviewContainer = styled.div`
  .preview-box {
    width: 200px;
    position: relative;
    .preview-text {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
    svg {
      opacity: 0.08;
    }
  }
  width: fit-content;
  margin-bottom: 10px;
`;
const PreviewQrSection = () => {
  const url = 'https://example.com/preview-only';
  return (
    <PreviewContainer>
      <div className="preview-box">
        <QrCodeSvg url={url} />
        <h4 className="preview-text">Preview</h4>
      </div>
      <AlertMessage
        alertIcon
        message="Preview only. Save and publish to activate and download QR code."
        dismissable={false}
        type="warning"
      />
    </PreviewContainer>
  );
};

const NewTabLink = ({ url }) => (
  <a href={url} target="_blank" rel="noreferrer">
    {url}
  </a>
);

const Execution = ({ execution: { name, destination_url, qr: { qr_path } = {} } }) => {
  const qrSection = qr_path ? (
    <QrSection title={name} url={`${window.location.origin}${qr_path}`} />
  ) : (
    <PreviewQrSection />
  );
  const shortCode = qr_path?.split('/')?.pop() || 'n/a';
  const qrUrl = `${window.location.origin}${qr_path}`;

  return (
    <div>
      <h3>
        {name || 'Unnamed Execution'} ({shortCode})
      </h3>
      {qrSection}
      <h4>QR URL: {qr_path ? <NewTabLink url={qrUrl} /> : 'n/a'}</h4>
      <h4>
        Destination URL: <NewTabLink url={destination_url} />
      </h4>
    </div>
  );
};

export const CampaignBuilderPreview = ({ name, id, description, executions }) => (
  <div>
    <h2>{name}</h2>
    <h4>ID: {id}</h4>
    <RichText content={description} />
    <h3>Executions</h3>
    <ul>
      {executions &&
        executions.map(e => (
          <li key={e.id} style={{ marginBottom: '30px', padding: '10px', borderBottom: '1px solid #ccc' }}>
            <Execution execution={e} />
          </li>
        ))}
    </ul>
  </div>
);

function getRoute(Board) {
  return Board.build.path.split('/').pop();
}

const CampaignBuilderPreviewWrapper = ({ value: { description, executions }, Board }) => (
  <CampaignBuilderPreview
    name={Board.build.name}
    id={getRoute(Board)}
    description={description}
    executions={executions}
  />
);

export default CampaignBuilderPreviewWrapper;
